var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { loading } from 'elements/Loading';
import { Form } from 'components';
import { FieldType } from 'elements';
import { rules } from 'helpers/Validation';
import { TypePassenger, TypePrice } from '../Model';
import { T as Traduce, t } from 'helpers/i18n';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.typePassengers = Object.entries(TypePassenger).map(function (item) {
            // console.log('name', item[1])
            return ({
                name: t("typePassenger:".concat(item[1])),
                value: item[1]
            });
        });
        _this.typePrices = Object.entries(TypePrice).map(function (item) { return ({
            name: t(item[1]),
            value: item[1]
        }); });
        _this.fields = [
            {
                name: 'name',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 6
            },
            {
                name: 'code',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 4
            },
            {
                name: 'type',
                type: FieldType.Select,
                rules: rules().string().required(),
                options: _this.typePassengers,
                size: 4
            },
            {
                name: 'typePrice',
                type: FieldType.Select,
                rules: rules().string().required(),
                options: _this.typePrices,
                size: 4
            },
            {
                name: 'required',
                type: FieldType.Checkbox,
                rules: rules().boolean(),
                options: _this.typePrices,
                size: 4
            },
            {
                name: 'minToReserve',
                type: FieldType.Number,
                rules: rules()
                    .minorAnotherField('maxToReserve', t('maxToReserve'))
                    .integer(),
                size: 2,
                tooltipId: 'minToReserve',
                tooltip: Traduce('minToReserve')
            },
            {
                name: 'maxToReserve',
                type: FieldType.Number,
                rules: rules()
                    .majorAnotherField('minToReserve', t('minToReserve'))
                    .integer(),
                size: 2,
                tooltipId: 'maxToReserve',
                tooltip: Traduce('maxToReserve')
            },
            {
                name: 'description',
                type: FieldType.TextArea,
                rules: rules()
                    .string(),
                size: 10
            }
        ];
        return _this;
    }
    default_1.prototype.render = function () {
        var passengerCategory = this.props.passengerCategory;
        var passengercategories = this.props.store.passengerCategories;
        return (React.createElement("div", null,
            React.createElement(Form, { delete: this.props.match.params.id, loading: ['post@passengercategories/', 'put@passengercategories/', 'delete@passengercategories/'], fields: this.fields, values: passengerCategory, store: passengercategories })));
    };
    default_1 = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id
                ? props.store.passengerCategories.read(Number(props.match.params.id)).then(function (passengerCategory) { return ({ passengerCategory: passengerCategory }); })
                : undefined
        ]; })
    ], default_1);
    return default_1;
}(Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/PassengerCategories/container/PassengerCategoriesForm.tsx
// module id = 1260
// module chunks = 0